<template>
  <div class="form_box_content">
    <div class="my_form2">
      <div class="form_title" style="min-height: 100px">{{ title1 }}</div>
      <div class="uploadinput">
        <div class="uploadlist" style="margin-left: 20px">
          <el-upload
            style="display: flex; align-items: center; margin-left: 10px"
            :action="$baseURL + '/api/home/upload/file/user'"
            :on-success="
              (value) => handenclosure('GreenConstruction', 1, value)
            "
            :on-remove="
              (value) => removeenclosure('GreenConstruction', 1, value)
            "
            :before-upload="beforeAvatarUpload"
            :file-list="parameters3.GreenConstruction"
            :limit="1"
            accept=".jpg, .png, .pdf, .doc, .docx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div
              slot="tip"
              style="margin-left: 10px"
              class="el-upload__tip"
              v-if="parameters3.GreenConstruction < 1"
            >
              只能上传png/jpg/pdf/doc文件，且不超过100MB
            </div>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="my_form">
      <div class="form_title" style="min-height: 100px">
        {{ title2 }}
      </div>
      <div class="uploadinput">
        <div class="uploadlist" style="margin-left: 20px">
          <el-upload
            style="display: flex; align-items: center; margin-left: 10px"
            :action="$baseURL + '/api/home/upload/file/user'"
            :on-success="
              (value) => handenclosure('GreenDeclarationForm', 2, value)
            "
            :on-remove="
              (value) => removeenclosure('GreenDeclarationForm', 2, value)
            "
            :before-upload="beforeAvatarUpload"
            :file-list="parameters3.GreenDeclarationForm"
            :limit="1"
            accept=".jpg, .png, .pdf, .doc, .docx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div
              slot="tip"
              style="margin-left: 10px"
              class="el-upload__tip"
              v-if="parameters3.GreenDeclarationForm < 1"
            >
              只能上传png/jpg/pdf/doc文件，且不超过100MB
            </div>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title1:{
      type:String,
      default:""
    },
    title2:{
      type:String,
      default:""
    },
    parameters3: {
      type: Object,
      default: () => {
        return{
          GreenConstruction: [],
          GreenDeclarationForm: [],
        }
      },
    },
  },
  data() {
    return {
      isArrNull: false,
    };
  },
  mounted() {
    setTimeout(() => {
      if (
        this.parameters3.GreenConstruction.length < 1 ||
        this.parameters3.GreenDeclarationForm.length < 1
      ) {
        this.isArrNull = false;
      } else {
        this.isArrNull = true;
      }
      this.$emit("greenPorject", this.parameters3, this.isArrNull);
    }, 1000);
  },
  methods: {
    handenclosure(name, index, value) {
      this.isArrNull = false;
      let obj = {
        url: value.data.host + value.data.url,
        name: value.data.originalName,
      };
      this.parameters3[name] = [obj];
      if (
        this.parameters3.GreenConstruction.length < 1 ||
        this.parameters3.GreenDeclarationForm.length < 1
      ) {
        this.isArrNull = false;
      } else {
        this.isArrNull = true;
      }
      this.$emit("greenPorject", this.parameters3, this.isArrNull);
    },
    removeenclosure(name, index, value) {
      this.parameters3[name] = [];
      this.$emit("greenPorject", this.parameters3, false);
    },
    beforeAvatarUpload(file) {
      let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
      if (filesize > 100) {
        this.$message.error("上传文件不能大于100MB");
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.my_form,
.my_form2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: visible;
  align-items: stretch;
  .form_title {
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 6px;
    box-sizing: border-box;
    color: #0c0d0f;
  }
  .uploadinput {
    width: 100%;
    background: #f5f8fb;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .uploadlist {
      display: flex;
      align-items: center;
      position: relative;
      .tipserror {
        width: 207px;
        height: 40px;
        background: #fcf4f4;
        border: 1px solid #ffc4c8;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 6px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 40px;
        color: #7c828a;
        position: absolute;
        z-index: 999999999;
        top: -40px;
        left: 20px;
        img {
          width: 14px;
          height: 14px;
        }
        &::before {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          display: inline-block;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid #ff989f;
        }
      }
    }
    .tipst {
      .tipserror {
        top: -26px;
      }
    }
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content,
  .form_long,
  .form_choice {
    width: 300px;
    padding: 0px 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content {
    position: relative;
    .tipserror {
      width: 207px;
      height: 40px;
      background: #fcf4f4;
      border: 1px solid #ffc4c8;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 6px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;
      color: #7c828a;
      position: absolute;
      z-index: 999999999;
      top: -36px;
      img {
        width: 14px;
        height: 14px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #ff989f;
      }
    }
  }
  .form_choice_long {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 729px;
    padding-left: 20px;
    box-sizing: border-box;
    background: #f5f8fb;
  }
  .form_long {
    width: 729px;
    input {
      width: 688px;
    }
  }
  .form_textarea {
    width: 729px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
      width: 688px;
      height: 127px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 9px 15px;
      box-sizing: border-box;
      color: #000;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
  }
  .uploadimg {
    width: 729px;
    padding: 20px;
    background: #f5f8fb;
    box-sizing: border-box;
  }
  .Downinpustyle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #f5f8fb;
    .nejje {
      color: #194abe !important;
    }
  }
  .upload-demo {
    width: 729px;
    padding-left: 20px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100px;
    .el-upload__tip {
      margin-left: 10px;
    }
  }
}
.my_form2 {
  .form_title {
    background: #f5f8fb;
  }
  .form_content,
  .form_long,
  .form_textarea,
  .form_choice,
  .form_choice_long,
  .upload-demo,
  .Downinpustyle,
  .uploadinput {
    background: #fbfdff;
  }
}
.form_box_content {
  width: 100%;
  margin-top: 20px;
  .form_title {
    box-sizing: border-box;
    text-align: start;
    display: flex;
    align-items: center;
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 20px;
      color: #0c0d0f;
    }
    .delete_icon {
      cursor: pointer;
      margin-left: 10px;
      width: 61px;
      height: 25px;
      background: #ffffff;
      border: 1px solid #f9656f;
      opacity: 1;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      img {
        width: 13px;
        height: 14px;
      }
      p {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 20px;
        color: #f9656f;
      }
    }
  }
}
</style>